import { Route, Routes } from 'react-router-dom';
import Home from '@pages/home';
import Login from '@pages/login';
import StudioPage, { StudiosList } from './Studio';
import { ROUTES } from './routesUrls';
import AIProductPage, {
  AIProductBackgroundPage,
  AIProductSiloPage,
  AIProductsList,
  AIProductTextPage,
  AIProductReviewPage,
  AIProductDownloadPage,
  AIProductVideoPage,
} from './AIProduct';

const AppRoutes = () => (
  <Routes>
    <Route path={ ROUTES.HOME } exact element={ <Home /> } />
    <Route path={ ROUTES.LOGIN } exact element={ <Login /> } />
    <Route path={ `${ROUTES.STUDIO.ROOT}` } exact element={ <StudiosList /> } />
    <Route path={ `${ROUTES.STUDIO.ROOT}${ROUTES.STUDIO.NEW}` } exact element={ <StudioPage /> } />
    <Route path={ `${ROUTES.STUDIO.ROOT}${ROUTES.STUDIO.EDIT()}` } exact element={ <StudioPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}` } exact element={ <AIProductsList /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.NEW}` } exact element={ <AIProductPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.EDIT()}` } exact element={ <AIProductPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.SILO()}` } exact element={ <AIProductSiloPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.BACKGROUND()}` } exact element={ <AIProductBackgroundPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.VIDEO()}` } exact element={ <AIProductVideoPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.TEXT()}` } exact element={ <AIProductTextPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.CAPTION()}` } exact element={ <AIProductReviewPage /> } />
    <Route path={ `${ROUTES.AI_PRODUCT.ROOT}${ROUTES.AI_PRODUCT.DOWNLOAD()}` } exact element={ <AIProductDownloadPage /> } />

    <Route path={ `${ROUTES.SILO.ROOT}` } exact element={ <AIProductsList /> } />
    <Route path={ `${ROUTES.SILO.ROOT}${ROUTES.SILO.NEW}` } exact element={ <AIProductPage /> } />
    <Route path={ `${ROUTES.SILO.ROOT}${ROUTES.SILO.EDIT()}` } exact element={ <AIProductPage /> } />

    <Route path={ `${ROUTES.LIFESTYLE.ROOT}` } exact element={ <AIProductsList /> } />
    <Route path={ `${ROUTES.LIFESTYLE.ROOT}${ROUTES.LIFESTYLE.NEW}` } exact element={ <AIProductPage /> } />
    <Route path={ `${ROUTES.LIFESTYLE.ROOT}${ROUTES.LIFESTYLE.EDIT()}` } exact element={ <AIProductPage /> } />

    <Route path={ `${ROUTES.VIDEO.ROOT}` } exact element={ <AIProductsList /> } />
    <Route path={ `${ROUTES.VIDEO.ROOT}${ROUTES.VIDEO.NEW}` } exact element={ <AIProductPage /> } />
    <Route path={ `${ROUTES.VIDEO.ROOT}${ROUTES.VIDEO.EDIT()}` } exact element={ <AIProductPage /> } />

    <Route path={ `${ROUTES.DESCRIPTION.ROOT}` } exact element={ <AIProductsList /> } />
    <Route path={ `${ROUTES.DESCRIPTION.ROOT}${ROUTES.DESCRIPTION.NEW}` } exact element={ <AIProductPage /> } />
    <Route path={ `${ROUTES.DESCRIPTION.ROOT}${ROUTES.DESCRIPTION.EDIT()}` } exact element={ <AIProductPage /> } />
  </Routes>
);

export default AppRoutes;
